module.exports = __webpack_public_path__ + "img/8.ebd36119.png";